import { useContext, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import { ApiBbsContext } from "../../../utils/providers/apiBbsProvider";
import CardContent from "@material-ui/core/CardContent";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Typography from "@material-ui/core/Typography";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import RateReviewIcon from "@material-ui/icons/RateReview";
import CallMadeIcon from "@material-ui/icons/CallMade";
import CallReceivedIcon from "@material-ui/icons/CallReceived";

const useStyles = makeStyles({
  header: {
    textAlign: "center",
    background: "#E299B7",
    color: "#FFF",
  },
});

const ReviewCard = () => {
  const { profileData, setDrawerDataRaw } = useContext(ApiBbsContext);
  const classes = useStyles();

  return (
    profileData && (
      <Card>
        <CardHeader className={classes.header} title="Notes" />
        <CardContent>
          <List dense={true}>
            {profileData.average_review_score && (
              <ListItem>
                <ListItemIcon>
                  <RateReviewIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    component="p"
                  >
                    {"Note moyenne : " + profileData.average_review_score}
                  </Typography>
                </ListItemText>
              </ListItem>
            )}
            <ListItem>
              <ListItemIcon>
                <CallReceivedIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  component="p"
                  style={{
                    cursor:
                      profileData.reviews.total_count > 0
                        ? "pointer"
                        : "default",
                  }}
                  onClick={() =>
                    profileData.reviews.total_count > 0 &&
                    setDrawerDataRaw(profileData.reviews.data, "user")
                  }
                >
                  {profileData.reviews.total_count +
                    (profileData.reviews.total_count > 1
                      ? " notes reçues"
                      : " note reçue")}
                </Typography>
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CallMadeIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  component="p"
                  style={{
                    cursor:
                      profileData.given_reviews.total_count > 0
                        ? "pointer"
                        : "default",
                  }}
                  onClick={() =>
                    profileData.given_reviews.total_count > 0 &&
                    setDrawerDataRaw(
                      profileData.given_reviews.data,
                      "user_reviewed"
                    )
                  }
                >
                  {profileData.given_reviews.total_count +
                    (profileData.given_reviews.total_count > 1
                      ? " notes données"
                      : " note donnée")}
                </Typography>
              </ListItemText>
            </ListItem>
          </List>
        </CardContent>
      </Card>
    )
  );
};

export default ReviewCard;
